import React, { useEffect, useState } from 'react';
import '../../styles/SupportPlanModal.css';

const SupportPlanModal = ({ show, onClose, loginCode, onUpdated }) => {
  const [plan, setPlan] = useState({
    longTermGoal: '',
    shortTermGoal: '',
    needs: '',
    supportContent: '',
    goalDate: '',
  });

  const [loading, setLoading] = useState(false);
  const API_URL = "https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/dailyreport";

  // 🔸 モーダル表示時にデータ取得
  useEffect(() => {
    if (!show || !loginCode) return;

    const fetchSupportPlan = async () => {
      setLoading(true);
      try {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-support-plan',
            login_code: loginCode,
          }),
        });
        const data = await res.json();
        setPlan({
          longTermGoal: data.long_term_goal || '',
          shortTermGoal: data.short_term_goal || '',
          needs: data.needs || '',
          supportContent: data.support_content || '',
          goalDate: data.goal_date ? data.goal_date.split('T')[0] : '',
        });
      } catch (err) {
        alert('個別支援計画の取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    fetchSupportPlan();
  }, [show, loginCode]);

  const handleChange = (field) => (e) => {
    setPlan((prev) => ({
        ...prev,
        [field]: e.target.value
    }));
  };

  const handleSave = async () => {
    try {
        const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: 'upsert-support-plan',
            login_code: loginCode,
            plan: plan,
        }),
        });

        const data = await res.json();
        alert(data.message || '保存しました');

        if (onUpdated) onUpdated(); // 🔁 親に通知
    } catch (err) {
        alert('保存に失敗しました');
    }
  };


  if (!show) return null;

  return (
    <div className="support-modal-overlay">
      <div className="support-modal">
        <h2>個別支援計画</h2>

        {loading ? (
          <p>読み込み中...</p>
        ) : (
          <>
            <label>長期目標</label>
            <textarea value={plan.longTermGoal} onChange={handleChange('longTermGoal')} />

            <label>短期目標</label>
            <textarea value={plan.shortTermGoal} onChange={handleChange('shortTermGoal')} />

            <label>本人のニーズ</label>
            <textarea value={plan.needs} onChange={handleChange('needs')} />

            <label>個別支援内容</label>
            <textarea value={plan.supportContent} onChange={handleChange('supportContent')} />

            <label>目標達成時期</label>
            <input type="date" value={plan.goalDate} onChange={handleChange('goalDate')} />
          </>
        )}

        <div className="support-modal-actions">
          <button className="custom-button" onClick={handleSave} disabled={loading}>
            保存
          </button>
          <button className="custom-button" onClick={onClose}>閉じる</button>
        </div>
      </div>
    </div>
  );
};

export default SupportPlanModal;
